import { ChatCompletionRequestMessage,OpenAIApi} from "./api";
import { db } from "../db";
import { defaultModel } from "./constants";
import { Configuration } from "./configuration";

function getClient(apiKey: string) {
  const configuration = new Configuration({
    apiKey,
  });
  delete configuration.baseOptions.headers['User-Agent'];
  return new OpenAIApi(configuration);
}

export async function createChatCompletion(
  apiKey: string,
  messages: ChatCompletionRequestMessage[]
) {
  const settings = await db.settings.get("general");
  const model = settings?.openAiModel ?? defaultModel;

  const client = getClient(apiKey);
  return client.createChatCompletion({
    model,
    stream: false,
    messages,
  });
}

export async function checkOpenAIKey(apiKey: string) {
  return createChatCompletion(apiKey, [
    {
      role: "user",
      content: "hello",
    },
  ]);
}
